import Vue from 'vue'

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default (/* { app, router, Vue ... } */) => {
  const vars = {
    table: {
      pagination: {
        rowsPerPage: 10,
        sortBy: null
      },
      'rows-per-page-options': [
        0
      ]
    },
  }

  Vue.prototype.$vars = vars
}
